import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../data/site';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="scroll-mt-16 bg-white py-10 sm:py-16" data-id="element-39" data-mp="1bl22x76f94dy">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-40" data-mp="1bmv9ynky5qmh">
        <h2 className="font-display text-[1.75rem] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-41" data-mp="1gkes3ykrmnjp">
          Preguntas frecuentes
        </h2>
        <ul className="mt-5 divide-y divide-steel-200 border-y border-steel-200" data-id="element-42" data-mp="28arvm6v8rc4k">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} data-id="element-43" data-mp="1uhk40f75ugmv" data-mpi={index}>
                <h3 data-id="element-44" data-mp="1zhy0czzeg252">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} onClick={() => setOpen(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 py-4 text-left" data-id="element-45" data-mp="1zhg07s9m93rv">
                    <span className="font-display text-lg font-semibold text-navy-900 sm:text-xl" data-id="element-46" data-mp="14sxunmupmqqd">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-steel-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-47" data-mp="1el3m8vh1v651" />
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} hidden={!isOpen} className="pb-4 pr-8 text-sm leading-relaxed text-steel-600 sm:text-[15px]" data-id="element-48" data-mp="1jj52z9r06tdc">
                  {faq.a}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}